var _excluded = ["palette"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var deepmerge = require('deepmerge');

export var paletteFamilies = ['primary', 'secondary', 'text', 'highlight', 'success', 'error', 'warning', 'alert', 'caution', 'notify', 'pricePrimary', 'priceSecondary', 'promoPrimary', 'promoSecondary', 'border', 'background'];
/**
 * Create the palette based on passed in theme
 *
 * @param {Object=} palette The passed in palette
 * @param {Object}  theme   The passed in theme
 *
 * @returns {Object} The generated palette
 */

export var createPalette = function createPalette(_ref) {
  var _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? {} : _ref$palette,
      theme = _objectWithoutProperties(_ref, _excluded);

  var _theme$colors = theme.colors,
      lightBlue = _theme$colors.lightBlue,
      tintBlue = _theme$colors.tintBlue,
      blue = _theme$colors.blue,
      toneBlue = _theme$colors.toneBlue,
      darkBlue = _theme$colors.darkBlue,
      shadeBlue = _theme$colors.shadeBlue,
      lightGreen = _theme$colors.lightGreen,
      tintGreen = _theme$colors.tintGreen,
      green = _theme$colors.green,
      toneGreen = _theme$colors.toneGreen,
      darkGreen = _theme$colors.darkGreen,
      shadeGreen = _theme$colors.shadeGreen,
      lightRed = _theme$colors.lightRed,
      tintRed = _theme$colors.tintRed,
      red = _theme$colors.red,
      toneRed = _theme$colors.toneRed,
      darkRed = _theme$colors.darkRed,
      shadeRed = _theme$colors.shadeRed,
      lightOrange = _theme$colors.lightOrange,
      tintOrange = _theme$colors.tintOrange,
      orange = _theme$colors.orange,
      toneOrange = _theme$colors.toneOrange,
      darkOrange = _theme$colors.darkOrange,
      shadeOrange = _theme$colors.shadeOrange,
      lightYellow = _theme$colors.lightYellow,
      tintYellow = _theme$colors.tintYellow,
      yellow = _theme$colors.yellow,
      toneYellow = _theme$colors.toneYellow,
      darkYellow = _theme$colors.darkYellow,
      shadeYellow = _theme$colors.shadeYellow,
      lightPurple = _theme$colors.lightPurple,
      tintPurple = _theme$colors.tintPurple,
      purple = _theme$colors.purple,
      tonePurple = _theme$colors.tonePurple,
      darkPurple = _theme$colors.darkPurple,
      shadePurple = _theme$colors.shadePurple,
      lightPink = _theme$colors.lightPink,
      tintPink = _theme$colors.tintPink,
      pink = _theme$colors.pink,
      tonePink = _theme$colors.tonePink,
      darkPink = _theme$colors.darkPink,
      shadePink = _theme$colors.shadePink,
      lightestText = _theme$colors.lightestText,
      lightText = _theme$colors.lightText,
      tintText = _theme$colors.tintText,
      text = _theme$colors.text,
      darkText = _theme$colors.darkText,
      headingText = _theme$colors.headingText,
      lightHighlight = _theme$colors.lightHighlight,
      tintHighlight = _theme$colors.tintHighlight,
      highlight = _theme$colors.highlight,
      toneHighlight = _theme$colors.toneHighlight,
      darkHighlight = _theme$colors.darkHighlight,
      shadeHighlight = _theme$colors.shadeHighlight,
      lightestBackground = _theme$colors.lightestBackground,
      lightBackground = _theme$colors.lightBackground,
      tintBackground = _theme$colors.tintBackground,
      background = _theme$colors.background,
      toneBackground = _theme$colors.toneBackground,
      darkBackground = _theme$colors.darkBackground,
      shadeBackground = _theme$colors.shadeBackground,
      darkestBackground = _theme$colors.darkestBackground,
      lightBorder = _theme$colors.lightBorder,
      tintBorder = _theme$colors.tintBorder,
      border = _theme$colors.border,
      toneBorder = _theme$colors.toneBorder,
      darkBorder = _theme$colors.darkBorder,
      shadeBorder = _theme$colors.shadeBorder;
  return deepmerge({
    primary: {
      light: lightBlue,
      tint: tintBlue,
      base: blue,
      tone: toneBlue,
      dark: darkBlue,
      shade: shadeBlue
    },
    secondary: {
      light: lightGreen,
      tint: tintGreen,
      base: green,
      tone: toneGreen,
      dark: darkGreen,
      shade: shadeGreen
    },
    text: {
      lightest: lightestText,
      light: lightText,
      tint: tintText,
      base: text,
      dark: darkText,
      heading: headingText
    },
    highlight: {
      light: lightHighlight,
      tint: tintHighlight,
      base: highlight,
      tone: toneHighlight,
      dark: darkHighlight,
      shade: shadeHighlight
    },
    success: {
      light: lightGreen,
      tint: tintGreen,
      base: green,
      tone: toneGreen,
      dark: darkGreen,
      shade: shadeGreen
    },
    error: {
      light: lightRed,
      tint: tintRed,
      base: red,
      tone: toneRed,
      dark: darkRed,
      shade: shadeRed
    },
    warning: {
      light: lightRed,
      tint: tintRed,
      base: red,
      tone: toneRed,
      dark: darkRed,
      shade: shadeRed
    },
    alert: {
      light: lightOrange,
      tint: tintOrange,
      base: orange,
      tone: toneOrange,
      dark: darkOrange,
      shade: shadeOrange
    },
    caution: {
      light: lightYellow,
      tint: tintYellow,
      base: yellow,
      tone: toneYellow,
      dark: darkYellow,
      shade: shadeYellow
    },
    notify: {
      light: lightYellow,
      tint: tintYellow,
      base: yellow,
      tone: toneYellow,
      dark: darkYellow,
      shade: shadeYellow
    },
    pricePrimary: {
      light: lightGreen,
      tint: tintGreen,
      base: green,
      tone: toneGreen,
      dark: darkGreen,
      shade: shadeGreen
    },
    priceSecondary: {
      light: lightBlue,
      tint: tintBlue,
      base: blue,
      tone: toneBlue,
      dark: darkBlue,
      shade: shadeBlue
    },
    strike: {
      base: red
    },
    promoPrimary: {
      light: lightPurple,
      tint: tintPurple,
      base: purple,
      tone: tonePurple,
      dark: darkPurple,
      shade: shadePurple
    },
    promoSecondary: {
      light: lightPink,
      tint: tintPink,
      base: pink,
      tone: tonePink,
      dark: darkPink,
      shade: shadePink
    },
    border: {
      light: lightBorder,
      tint: tintBorder,
      base: border,
      tone: toneBorder,
      dark: darkBorder,
      shade: shadeBorder
    },
    background: {
      lightest: lightestBackground,
      light: lightBackground,
      tint: tintBackground,
      base: background,
      tone: toneBackground,
      dark: darkBackground,
      shade: shadeBackground,
      darkest: darkestBackground
    }
  }, palette);
};